import React from "react";
import { useSelector } from "react-redux";
import { Progress } from "reactstrap";

export default function UploadProgressStrip() {
    const uploadInProgress = useSelector((s) => s.postReducer.uploadInProgress);
    const progress = useSelector((s) => s.postReducer.uploadProgress);
    const statusText = useSelector((s) => s.postReducer.uploadStatusText);
    const sizeInfo = useSelector((s) => s.postReducer.uploadSizeInfo);

    if (!uploadInProgress || progress <= 0) return null;

    const icon = statusText === 'Compressing...'
        ? 'fa-compress'
        : statusText === 'Uploading...'
            ? 'fa-cloud-upload-alt'
            : 'fa-check-circle';

    return (
        <div className="bg-white shadow-sm rounded-3 mb-2 px-3 py-2">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                <span style={{ fontSize: '13px', fontWeight: 600, color: '#555' }}>
                    {statusText && <><i className={`fas ${icon} me-1`} />{statusText}</>}
                </span>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {sizeInfo && (
                        <span style={{ fontSize: '12px', color: '#45bd62', fontWeight: 600 }}>
                            {sizeInfo.original} → {sizeInfo.compressed}
                        </span>
                    )}
                    <span style={{ fontSize: '12px', color: '#65676b', fontWeight: 600 }}>
                        {Math.round(progress)}%
                    </span>
                </div>
            </div>
            <Progress
                value={progress}
                color={progress >= 100 ? 'success' : progress >= 80 ? 'info' : 'primary'}
                style={{ height: '6px', borderRadius: '3px' }}
            />
        </div>
    );
}
